export default defineNuxtRouteMiddleware(async () => {
  const appConfig = useAppConfig();

  if (appConfig.loadFeatures) {
    const featuresConfig = await getCachedFeatureFlags();

    if (featuresConfig) {
      appConfig.features = featuresConfig;
    }
  }
});
